(function WebShipsView($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Ships/view/', function onload() {

			// The following is to display arrows on tables for smaller screens.
			var table = $('.nav-arrows').parent().find('table'); 
			Adzuki.TableArrows(table);
		});
	});

}(jQuery, window.Adzuki || {}));
